import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  IMarkAsReadResponse,
  InfoNotification,
  INotificationResponse,
  NotificationsLabels as LABELS,
  legendsList,
} from "./NotificationsConstants";
import MarkAsReadIcon from "../../assets/mark-as-read.svg";
import MapModulesToIcons, {
  MapNotificationsToIcons,
} from "../../utils/helpers/mapModulesToIcon";
import { useAppSelector } from "../../services/redux/hooks/hooks";
import {
  useAllNotificationsData,
  useMarkAllNotificationRead,
  useMarkNotificationRead,
  usenotificationFilters,
  useNotificationsCount,
  useNotificationsData,
  useNotificationsPageCount,
} from "../../react-query/hooks/HNotifications";
import { Accordion, Loader, SelectPicker } from "rsuite";
import { FaPlus, FaMinus } from "react-icons/fa";
import Button from "../../components/button";
import useResponsiveWidth from "../../react-query/hooks/useResponsiveWidth";
import { sortCommodityFirst } from "../../utils/helpers/commodityOrder";

const Notifications = () => {
  const width = useResponsiveWidth();
  const [commodity, setCommodity] = useState<string>("All");
  const userDetails = useAppSelector((state) => {
    return state.user;
  });
  const PlusIcon = FaPlus as React.FC;
  const MinusIcon = FaMinus as React.FC;

  let arr = userDetails?.district_level_data?.map(
    (item: any) => item?.COMMODITY
  );

  const uniqueArr = [];

  if (arr && arr.length) {
    for (let i = 0; i < arr.length; i++) {
      if (uniqueArr.indexOf(arr[i]) === -1) {
        uniqueArr.push(arr[i]);
      }
    }
  }

  let { notificationFilters, filtersLoaded } = usenotificationFilters(
    userDetails?.role_name,
    userDetails?.userEmail
  );
  let { notificationsCount, refetchCount } = useNotificationsPageCount(
    userDetails?.role_name,
    commodity === "All"
      ? notificationFilters && notificationFilters.length
        ? [...notificationFilters.map((ele: any) => ele.commodity)]
        : []
      : [commodity],
    userDetails?.userEmail
  );
  let { notificationsData, refetch, isLoading } = useAllNotificationsData(
    userDetails?.role_name,
    commodity === "All"
      ? notificationFilters && notificationFilters.length
        ? [...notificationFilters.map((ele: any) => ele.commodity)]
        : []
      : [commodity],
    userDetails?.userEmail
  );
  const { mutate } = useMarkNotificationRead(refetch, refetchCount);
  const { mutate: mutateAllNotification } = useMarkAllNotificationRead(
    refetch,
    refetchCount
  );

  useEffect(() => {
    if (notificationsData.data) {
      // setCommodity(notificationFilters[0].commodity);
      setActivekeyValue(
        userDetails?.role_name === "Manager"
          ? Object.keys(notificationsData.data)[1]
          : Object.keys(notificationsData.data)[0]
      );
    }
  }, [isLoading]);

  function capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  const capitalizeWords = (sentence: string) => {
    return sentence
      .split(" ")
      .map((word) => (word === "compliance" ? "Metrics" : capitalize(word)))
      .join(" ");
  };

  const formatDate = (givenDate: any) => {
    const date = new Date(givenDate);
    const month = date.toLocaleString("en-US", { month: "long" });
    const day = date.getDate();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const formatted = `${month} ${day}, ${hours}:${minutes} ${ampm}`;
    return formatted;
  };

  const mapActionToNotifications = (type: string, module: string) => {
    switch (true) {
      case type === "review" && module === "allocation summary":
        return (
          <Link
            to={{ pathname: "/allocation-summary" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "board cost trends":
        return (
          <Link
            to={{ pathname: "/cost-trend" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "cost compliance":
        return (
          <Link
            to={{ pathname: "/cost-metrics" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "committed vs actual":
        return (
          <Link
            to={{ pathname: "/volume-metrics" }}
            state={{ hiddenParam: "actualCommitedVol" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "market share compliance":
        return (
          <Link
            to={{ pathname: "/volume-metrics" }}
            state={{ hiddenParam: "allocationCompliance" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "upload" && module === "quote upload":
        return (
          <Link
            to={{ pathname: "/upload-quote" }}
            state={{ hiddenParam: "vendorQuote" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.upload}
          </Link>
        );
      case type === "upload" && module === "additional upload":
        return (
          <Link
            to={{ pathname: "/upload-quote" }}
            state={{ hiddenParam: "additionalInputs" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.upload}
          </Link>
        );
      case type === "review" && module === "quote details":
        return (
          <Link
            to={{ pathname: "/quote-assessment" }}
            state={{ hiddenParam: "quoteDetails" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "renegotiation summary":
        return (
          <Link
            to={{ pathname: "/quote-assessment" }}
            state={{ hiddenParam: "renegotiateSummary" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "sku ratio analysis":
        return (
          <Link
            to={{ pathname: "/quote-assessment" }}
            state={{ hiddenParam: "sKURatioAnalysis" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "volume allocation":
        return (
          <Link
            to={{ pathname: "/allocation" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "board cost setting":
        return (
          <Link
            to={{ pathname: "/cost-setting" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "trend reports":
        return (
          <Link
            to={{ pathname: "/reports" }}
            state={{ hiddenParam: "trendReports" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "additional upload":
        return (
          <Link
            to={{ pathname: "/upload-quote" }}
            state={{ hiddenParam: "additionalInputs" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "approval" && module === "board cost setting":
        return (
          <Link
            to={{ pathname: "/cost-setting" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.approve}
          </Link>
        );
      case type === "review" && module === "all modules":
        return (
          <Link
            to={{ pathname: "/home" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "approval" && module === "volume allocation":
        return (
          <Link
            to={{ pathname: "/allocation" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.approve}
          </Link>
        );
      case type === "review" && module === "volume allocation":
        return (
          <Link
            to={{ pathname: "/allocation" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "approval" && module === "business cost":
        return (
          <Link
            to={{ pathname: "/cost-setting" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.approve}
          </Link>
        );
      case type === "review" && module === "business cost":
        return (
          <Link
            to={{ pathname: "/cost-setting" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "compliance monitoring":
        return (
          <Link
            to={{ pathname: "/cost-metrics" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "info" && module === "compliance monitoring":
        return (
          <Link
            to={{ pathname: "/cost-metrics" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "info" && module === "volume allocation":
        return (
          <Link
            to={{ pathname: "/quote-assessment" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "info" && module === "business cost":
        return (
          <Link
            to={{ pathname: "/cost-setting" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "info" && module === "volume compliance":
        return (
          <Link
            to={{ pathname: "/volume-metrics" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
      case type === "review" && module === "volume compliance":
        return (
          <Link
            to={{ pathname: "/volume-metrics" }}
            state={{ hiddenParam: "" }}
            className="font-bold text-[0.8vw] pl-[0.2vw] text-deloitteGreen underline"
          >
            {LABELS.review}
          </Link>
        );
    }
  };

  const renderNotification = (
    notification: INotificationResponse,
    section: string
  ) => {
    let isReminder =
      userDetails?.role_name?.toLowerCase() === "lead" &&
      notification.type === "approval";
    return (
      <div
        key={notification.id}
        className="flex w-full justify-between items-center py-[0.8vw]"
      >
        {/* <div className="w-[90%] flex justify-start items-center gap-2">
          <span className="font-light text-[0.6vw] w-[5vw]">{`${formatDate(
            notification.dateTime
          )}`}</span>
          <div className="flex justify-start text-left gap-2">
            <span className="font-bold text-[0.8vw]">{`${capitalizeWords(
              notification?.module
            )}:`}</span>
            <span
              className="font-normal text-[0.8vw] pl-[0.2vw]"
              dangerouslySetInnerHTML={{
                __html: notification?.message,
              }}
            />
            {mapActionToNotifications(notification?.type, notification?.module)}
          </div>
        </div> */}

        <div className="w-[90%] flex justify-start items-center gap-2">
          <div className="font-light text-[0.6vw] w-[7vw]">
            {formatDate(notification.dateTime)}
          </div>
          <div className="flex justify-start items-center gap-2 w-[69vw] flex-wrap">
            <span className="font-bold text-[0.8vw]">
              {capitalizeWords(notification?.module) === "Market Share Metrics"
                ? "Market Share"
                : capitalizeWords(notification?.module)}
              :
            </span>
            <span
              className="font-normal text-[0.8vw] pl-[0.2vw]"
              dangerouslySetInnerHTML={{
                __html: notification?.message,
              }}
            />
            <span>
              {mapActionToNotifications(
                notification?.type,
                notification?.module
              )}
            </span>
          </div>
        </div>

        <div
          className={`bg-[#86BC25] flex py-[0.3vw] px-[0.5vw] mr-[1vw] rounded-lg items-center cursor-pointer w-[3.5vw] ${
            notification?.isMarkAsRead === false && "invisible"
          }`}
          onClick={() => handleMarkAsRead([notification], section)}
        >
          <span className="text-white px-[0.25vw] font-normal text-[0.8vw]">
            {LABELS.clear}
          </span>
        </div>
      </div>
    );
  };

  const handleMarkAsRead = (
    notification: INotificationResponse[],
    section: string
  ) => {
    let payload: IMarkAsReadResponse = {
      notifications: [],
      user_email: "",
      section: "",
      isInfo: false,
    };
    payload.notifications = [...notification.map((ele) => ele.id)];
    payload.user_email = userDetails?.userEmail;
    payload.isInfo = InfoNotification.includes(section.toLowerCase());
    payload.section = section.toLowerCase();
    mutate(payload);
  };

  const markAllAsRead = () => {
    mutateAllNotification(userDetails?.userEmail);
  };

  const [activeKeyValue, setActivekeyValue] = useState<
    string | number | undefined
  >("");

  const handleToggle = (key: string | number | undefined) => {
    if (activeKeyValue === key) {
      setActivekeyValue("");
    } else {
      setActivekeyValue(key);
    }
  };

  return (
    <div className="flex flex-col justify-stretch items-stretch h-full volume-allocation nia-container overflow-y-hidden overflow-x-hidden">
      {isLoading && filtersLoaded && (
        <Loader
          backdrop
          content="Loading..."
          size="md"
          vertical
          className="text-black font-bold"
          style={{ opacity: 0.8, zIndex: 9999 }}
        />
      )}
      <div className="grow shrink-0 basis-[17%] ps-[3%] pr-[4%] pt-[1.6%] flex flex-col flex-nowrap justify-start items-start gap-0 shadow-normal relative">
        <div className="flex justify-between items-center w-full">
          <div className="flex justify-start items-center w-[50%]">
            <div className="font-normal text-[2vw]">{LABELS.notifications}</div>
            {notificationsCount !== undefined && notificationsCount !== 0 && (
              <div
                className={`text-white flex justify-center items-center ${
                  notificationsCount === 0 && "invisible"
                } bg-deloitteGreen radius-[50%] h-[1.5vw] w-[1.5vw] relative top-[2px] flex justify-center items-center font-bold text-[0.9vw] ml-[1vw] rounded-full py-[0.25vw] px-[0.45vw] ${
                  notificationsCount > 99
                    ? "py-[0.30vw] px-[0.5vw] h-[2vw] w-[2vw] "
                    : ""
                }`}
              >
                {notificationsCount}
              </div>
            )}
          </div>
          <div className="flex flex-col items-end justify-center gap-4 w-[50%] mr-[2.5vw] pb-[1vh]">
            <div className="flex flex-col justify-start items-start">
              <label className="font-bold text-[0.8vw]">Commodity</label>

              <SelectPicker
                menuAutoWidth
                className="dropdown-responsive-width"
                labelKey="commodity"
                valueKey="commodity"
                value={commodity}
                placeholder="All"
                cleanable={false}
                style={{ width: width }}
                onChange={(value: string | null) => {
                  if (value) {
                    setCommodity(value);
                  }
                }}
                data={
                  notificationFilters && notificationFilters.length !== 0
                    ? [{ commodity: "All" }, ...sortCommodityFirst(notificationFilters)]
                    : [{ commodity: "All" }]
                }
              ></SelectPicker>
            </div>
            <div
              className={`bg-[#86BC25] flex py-[0.8vh] px-[0.5vw] rounded-lg items-center ${
                notificationsCount
                  ? "cursor-pointer"
                  : "cursor-not-allowed opacity-50"
              }`}
              onClick={() => (notificationsCount ? markAllAsRead() : null)}
            >
              <span className="text-white px-[0.25vw] font-normal text-[0.8vw] w-[5.5vw] text-center">
                {LABELS.clearAll}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#F1F1F1] grow shrink p-[2%] pr-[4%] flex flex-row flex-nowrap justify-between items-start gap-6 h-full w-full">
        <div className="bg-white w-full h-full flex flex-col flex-nowrap flex-shrink-0 p-[0.5vw] max-h-[75.5vh]">
          <div className="border-t-[0.01vw] border-[#EDEDED] w-full h-full divide-y-[0.01vw] overflow-y-auto custom-scrollbar">
            {notificationsData.data ? (
              <Accordion
                bordered
                activeKey={activeKeyValue}
                onSelect={(eventKey) => handleToggle(eventKey)}
              >
                {notificationsData.data &&
                  Object.keys(notificationsData.data).map(
                    (ele: any, i: number) =>
                      userDetails?.role_name === "Manager" &&
                      ele === "Requested Approvals" ? null : (
                        <Accordion.Panel
                          key={i}
                          header={
                            <div className="flex justify-between text-[0.8vw]">
                              <div className="flex justify-start items-center gap-2">
                                <div>
                                  {activeKeyValue === ele ? (
                                    <MinusIcon />
                                  ) : (
                                    <PlusIcon />
                                  )}
                                </div>
                                <div
                                  className={`text-white flex justify-center items-center ${
                                    notificationsData.data[ele].length === 0 &&
                                    "invisible"
                                  } bg-deloitteGreen h-[1.25vw] w-[1.25vw] relative flex justify-center items-center font-bold text-[0.6vw] rounded-full ${
                                    notificationsData.data[ele].length > 99
                                      ? "h-[1.3vw] w-[1.3vw] "
                                      : ""
                                  }`}
                                >
                                  {notificationsData.data[ele].length}
                                </div>
                                <div>{ele}</div>
                              </div>
                              <div>
                                <div
                                  className={`bg-[#86BC25] flex py-[1vh] px-[0.5vw] mr-[1vw] rounded-lg items-center ${
                                    notificationsData.data[ele].length
                                      ? "cursor-pointer"
                                      : "cursor-not-allowed opacity-50"
                                  }`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    notificationsData.data[ele].length
                                      ? handleMarkAsRead(
                                          notificationsData.data[ele],
                                          ele
                                        )
                                      : null;
                                  }}
                                >
                                  <span className="text-white px-[0.25vw] font-normal text-[0.8vw] w-[5.5vw] text-center">
                                    {LABELS.clearSection}
                                  </span>
                                </div>
                              </div>
                            </div>
                          }
                          eventKey={ele}
                          caretAs={() => null}
                        >
                          {notificationsData.data[ele].length !== 0 ? (
                            <div className="w-full max-h-[45vh] overflow-y-auto custom-scrollbar">
                              {notificationsData.data[ele].map(
                                (notificationObj: INotificationResponse) =>
                                  renderNotification(notificationObj, ele)
                              )}
                            </div>
                          ) : (
                            <div className="flex text-[0.8vw] h-full w-full items-center justify-start pl-[5vw]">
                              All caught up! Check back later for updates.
                            </div>
                          )}
                        </Accordion.Panel>
                      )
                  )}
              </Accordion>
            ) : (
              <Loader
                backdrop
                content="Loading..."
                size="md"
                vertical
                className="text-black font-bold"
                style={{ opacity: 0.8, zIndex: 9999 }}
              />
            )}
          </div>
          {/* {notificationsCount > 0 && (
            <div className="flex w-full justify-end items-center mt-[0.5vh] ">
              <div className="flex w-fit items-center bg-[#f2f2f2] py-[1vh] px-[1vw] border-transparent rounded-[0.5vh]">
                <div className="flex items-center text-[0.8vw] font-bold mr-[1vh]">
                  Legend
                </div>
                {legendsList.map((legend) => (
                  <div
                    key={legend.key}
                    className="flex items-center ml-[1.25vw]"
                  >
                    <img
                      className="w-[1.5vw] h-[1.5vw] border-transparent rounded-full"
                      src={MapNotificationsToIcons(
                        legend.key,
                        legend.isReminder
                      )}
                      alt={legend.value}
                    />
                    <span className="font-semibold italic text-[0.75vw] ml-[0.5vh] mr-[0.25vh]">
                      {legend.value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default Notifications;
